import React from "react";
import PropTypes from "prop-types";
import { Overlayer, Content, BtnClose, Wrapper, Header } from "./Modal.styles";

const Modal = ({ ...props }) => {
  return (
    props.show && (
      <Overlayer>
        <Wrapper
          width={props.width}
          height={props.height}
          mobileBorderRadius={props.mobileBorderRadius}
          mobileWidth={props.mobileWidth}
          mobileHeight={props.mobileHeight}
        >
          {props.header ? (
            props.header
          ) : (
            <Header>
              <BtnClose onClick={props.onClose}>
                <span aria-hidden="true">&times;</span>
              </BtnClose>
            </Header>
          )}
          <Content
            contentMargin={props.contentMargin}
            contentMaxWidth={props.contentMaxWidth}
            contentPaddingTop={props.contentPaddingTop}
            contentJustifyContent={props.contentJustifyContent}
            contentAlignItems={props.contentAlignItems}
            contentPaddingTopMobile={props.contentPaddingTopMobile}
            position={props.position}
            contentHeightPercent={props.contentHeightPercent}
          >
            {props.children}
          </Content>
        </Wrapper>
      </Overlayer>
    )
  );
};

Modal.propTypes = {
  onClose: PropTypes.func,
  show: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  width: PropTypes.number,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mobileBorderRadius: PropTypes.number,
  mobileWidth: PropTypes.string,
  mobileHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mobileBackgroundColor: PropTypes.string,
  contentMargin: PropTypes.number,
  contentMaxWidth: PropTypes.number,
  contentPaddingTop: PropTypes.number,
  contentJustifyContent: PropTypes.string,
  contentAlignItems: PropTypes.string,
  contentPaddingTopMobile: PropTypes.number,
  contentHeightPercent: PropTypes.string,
  header: PropTypes.node,
  position: PropTypes.string,
};

Modal.defaultProps = {
  width: 300,
  height: "auto",
  mobileBorderRadius: 0,
  mobileWidth: "100%",
  mobileHeight: "100%",
  mobileBackgroundColor: "white",
  contentMargin: 1.75,
  contentMaxWidth: 528,
  contentPaddingTop: 30,
  contentJustifyContent: "center",
  contentAlignItems: "center",
  contentPaddingTopMobile: 150,
  contentHeightPercent: undefined,
  header: undefined,
  onClose: undefined,
  position: "relative",
};

export default Modal;
